import styled from '@emotion/styled';
import { cloudPlatformIcon } from '@workday/canvas-accent-icons-web';
import { AccentIcon } from '@workday/canvas-kit-react/icon';
import * as React from 'react';
import { Canvas } from '../Canvas';
import { DevsiteModalHeading } from './PopupContext';

interface ExtendPopupProps {
  title?: string;
  hideCloudPlatformIcon?: boolean;
  leftAlign?: boolean;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
  firstFocusRef?: any;
}

export const ExtendPopup: React.FC<React.PropsWithChildren<ExtendPopupProps>> = ({
  children,
  firstFocusRef,
  hideCloudPlatformIcon,
  title,
  ...elemProps
}) => (
  <PopupContainer ref={firstFocusRef} {...elemProps}>
    {!hideCloudPlatformIcon && <AccentIcon icon={cloudPlatformIcon} />}
    {title && <DevsiteModalHeading>{title}</DevsiteModalHeading>}
    {children}
  </PopupContainer>
);

const PopupContainer = styled(Canvas.Modal.Body)<{ leftAlign?: boolean }>`
  text-align: ${(props) => (props.leftAlign ? 'left' : 'center')};
`;
